import Vue from 'vue';
import App from './App.vue';
import router from './router';

import 'swiper/dist/css/swiper.min.css'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.config.productionTip = false;

// eden
// axios请求
import axios from 'axios';
Vue.prototype.$axios = axios;

new Vue({
    render: (h) => h(App),
    router,
    created() {
        // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
        setRem();
        window.addEventListener('resize', setRem); //浏览器窗口大小改变时调用rem换算方法
    },
}).$mount('#app');
// 手机端
function setRem() {
    var whdef = 100 / 540; // 表示750的设计图,使用100PX的默认值
    var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
    var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
    document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}

// router.afterEach((to,from,next) =>{
//   window.scrollTo(0,0)
// })
